import { InjectionToken } from '@angular/core';
import { ISymptomService } from './symptom-service.interface';

export const SYMPTOM_SERVICE = new InjectionToken<ISymptomService>(
  'SYMPTOM_SERVICE'
);
